import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { PinnedViewsBar } from 'customer-data-views-management/pinnedViews/components/PinnedViewsBar';
import { UI_MODE } from 'framework-listing-lib/constants';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { useHasFoldersTab } from 'framework-listing-lib/internal/Folders/hooks/useFolderProps';
import { useCurrentViewId, useOnViewIdChange, useViewsNamespace } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { useIsFoldersMode, useOnChangeUIMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import ListingLibAllViewsLink from './ListingLibAllViewsLink';
import ListingLibCreateViewModal from './ListingLibCreateViewModal';
import ListingLibViewName from './ListingLibViewName';
import ViewFoldersTab from './ViewFoldersTab';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewTabsDnDV2({
  isMockViewTabsForFolders,
  onTabClick
}) {
  const objectTypeId = useObjectTypeId();
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const currentViewId = useCurrentViewId();
  const namespace = useViewsNamespace();
  const onViewIdChange = useOnViewIdChange();
  const isFoldersMode = useIsFoldersMode();
  const hasFoldersTab = useHasFoldersTab();
  const onChangeUIMode = useOnChangeUIMode();
  const {
    onClearFilters
  } = useCrmObjectTypeListingFilters();
  const handleFoldersTabClick = useCallback(() => {
    if (isFoldersMode) {
      return;
    }
    trackCrmTableInteraction({
      action: 'click-folders-tab'
    });
    if (isMockViewTabsForFolders) {
      onTabClick === null || onTabClick === void 0 || onTabClick('folder-tab');
      return;
    }
    onClearFilters({
      newUIMode: UI_MODE.FOLDERS
    });
    onChangeUIMode(UI_MODE.FOLDERS);
  }, [isFoldersMode, isMockViewTabsForFolders, onChangeUIMode, onClearFilters, onTabClick, trackCrmTableInteraction]);
  const handleViewIdChange = useCallback(newViewId => {
    /**
     * PinnedViewsBar triggers the onChange event even when the currentViewId is the same as the newViewId.
     */
    if (newViewId === currentViewId) {
      return;
    }
    trackCrmTableInteraction({
      action: 'change-view',
      viewId: newViewId
    });
    onViewIdChange(newViewId);
    onTabClick === null || onTabClick === void 0 || onTabClick('view-tab', newViewId);
  }, [currentViewId, onTabClick, onViewIdChange, trackCrmTableInteraction]);
  return /*#__PURE__*/_jsxs(Flex, {
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    borderBlockEndColor: "border-tertiary-default",
    justifyContent: "space-between",
    "data-test-id": "view-tabs-dnd-v2",
    children: [/*#__PURE__*/_jsx(PinnedViewsBar
    /**
     * PinnedViewsBar requires the "idLabel" from views that have that property.
     * Otherwise a new "ghost tab" is created.
     * When in folders mode, the currentViewId should be set to null.
     */, {
      currentViewId: isFoldersMode || isMockViewTabsForFolders ? null : currentViewId || null,
      namespace: namespace,
      objectTypeId: objectTypeId,
      onCurrentViewIdChange: handleViewIdChange
      /**
       * This property is required but it is not being internally used by PinnedViewsBar
       */,
      returnLink: window.location.toString(),
      AllViewsLinkImplementation: ListingLibAllViewsLink,
      CreateViewModalImplementation: ListingLibCreateViewModal,
      ViewNameImplementation: ListingLibViewName
    }), hasFoldersTab ? /*#__PURE__*/_jsx("div", {
      "data-test-id": "folders-tab-wrapper-test",
      children: /*#__PURE__*/_jsx(ViewFoldersTab, {
        isFoldersMode: isFoldersMode || isMockViewTabsForFolders,
        onTabClick: handleFoldersTabClick
      })
    }) : null]
  });
}